import React, { useEffect, useState } from "react";
import "./UserAssessments.css";
import { FaEdit } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import DailyGoals from "components/DailyGoals/DailyGoals";
import CaloriesIcon from "assets/svg_icons/calories_icon.svg";
import StepsIcon from "assets/svg_icons/steps_icon.svg";
import SocialMediaIcon from "assets/svg_icons/social_media_icon.svg";
import CoinsIcon from "assets/svg_icons/coins.svg";
import StreakIcon from "assets/svg_icons/streak_fire.svg";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";
import { getAssessmentData } from "actions/dataLoad";
import { useUserInfoSelector, useUserTokenSelector } from "store/reducers";
import { Link, useHistory } from "react-router-dom";
import { loadAllQuiz } from "actions/quiz";
import { IoSearch } from "react-icons/io5";
import { motion } from "motion/react";
import Lottie from "lottie-react";
import { Assessment } from "Containers/Assessment/Assessment";
import UserAssessmentsSkeleton from "./UserAssessmentsSkeleton";

const UserAssessments = ({ showError }) => {
  const [assessments, setAssessments] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showAssessment, setShowAssessment] = useState(false);
  const userInfo = useUserInfoSelector();
  const [assessment, setAssessment] = useState(null);
  const [aindex, setAindex] = useState();
  const userToken = useUserTokenSelector();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const loadAssessments = async () => {
    try {
      // dispatch(startLoading());
      setLoading(true);
      const res = await loadAllQuiz(userToken);
      setAssessments(res.data);
      // dispatch(stopLoading());
      setLoading(false);
    } catch (err) {
      console.warn(err);
      // dispatch(stopLoading());
      setLoading(false);
      if (err.response?.data?.redirectToSignIn) {
        showError(err.response.data.error);
        setTimeout(
          () =>
            history.push({
              pathname: "/signin",
              state: { referer: location.pathname },
            }),
          3000
        );
      } else {
        showError(err.response?.data?.error);
      }
    }
  };

  const filteredAssessments = assessments.filter((item) => {
    return item.name.toLowerCase().includes(searchText.toLowerCase());
  });

  useEffect(() => {
    loadAssessments();
  }, []);

  const truncateText = (text, limit) => {
    return text.length > limit ? `${text.slice(0, limit)}.....` : text;
  };

  const handleCloseAssessment = () => {
    setAssessment(null);
    setAindex(null);
    setShowAssessment(false);
    history.push("/dashboard/assessments");
  };

  const handleShowAssessment = (assessment, index) => {
    setAssessment(assessment);
    setAindex(index);
    setShowAssessment(true);
    history.push("/dashboard/assessments/view/" + assessment._id);
  };
  if (loading) {
    return (
      <div className="assessments-page">
        <UserAssessmentsSkeleton />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="assessments-page"
    >
      {showAssessment ? (
        <Assessment
          onClose={handleCloseAssessment}
          assessment={assessment}
          AssessmentId={assessment._id}
        />
      ) : (
        <>
          <div className="assessments-heading">
            <h1>Assessments</h1>
          </div>
          <div className="assessments-searchbar">
            <IoSearch size={20} />
            <input
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <div className="assessments-container">
            {filteredAssessments.map((a, index) => {
              return (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  to={`/dashboard/assessments/${a.urlSlug}`}
                  className="assessment-card"
                  onClick={() => handleShowAssessment(a, index)}
                >
                  <div className="assessment-card-content">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        width: "90%",
                        justifyContent: "center",
                        borderRadius: 16,
                        overflow: "hidden",
                        marginBottom: 10,
                      }}
                    >
                      <img
                        src={a.imageUrl}
                        style={{ width: "100%", maxHeight: 120 }}
                      />
                    </div>
                    <h3>{a.name}</h3>
                    <p>{truncateText(a.description, 100)}</p>
                  </div>
                  <div className="card-bottom">
                    <div className="flex-auto assessment-card-details">
                      {a.timeDuration} min
                    </div>
                    <div className="flex-auto  assessment-card-details">
                      {a.totalQuestions} questions
                    </div>
                  </div>
                  {/* <Link to={`/dashboard/assessments/${a.urlSlug}`} className="assessment-card-btn">
                Take Quiz Now
              </Link> */}
                </motion.div>
              );
            })}
          </div>
        </>
      )}
    </motion.div>
  );
};

export default UserAssessments;
